import React from 'react';

const TaxIssuedAddPage = () => {
  return <div></div>;
};

export default TaxIssuedAddPage;
